module.exports = __webpack_public_path__ + "static/media/2.5d64ea73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/slides/Designbase/assets/2.jpg
// module id = 62
// module chunks = 0